import { DEMO_COMPANY, RAJESH_TRANSPORT, STA_COMPANY_ID } from "../../../helper/companyIdhardcode"
import { encrypt } from "../../common/loginDecode"

export const generalReports = (intCompanyID) => [
    { name: 'Daily Branch Collection', JobID: 470, reportNo: 1 }, //v2
    { name: 'Booking Report', JobID: 465, reportNo: 2 }, //v2
    // { name: 'Dispatch Report', JobID: 457, reportNo: 3 }, //v2
    // { name: 'Receive Report', JobID: 461, reportNo: 4 }, //v2
    { name: 'Delivery Report', JobID: 467, reportNo: 5 }, //v2
    { name: 'Refund Report', JobID: 549, reportNo: 19 }, //v2
    { name: 'Branch Transfer', JobID: 462, reportNo: 6 }, //v2
    { name: 'Branch Transfer Received', JobID: 463, reportNo: 7 }, //v2
    { name: 'On-Account Credit', JobID: 484, reportNo: 8 }, //v2
    { name: 'Analysis Report', JobID: 90, reportNo: 9, encryptParams: true }, //v1
    { name: 'Nonmovement Report', JobID: 486, reportNo: 10 }, //v1
    { name: 'Quick View Report', JobID: 479, reportNo: 11 }, //v3
    { name: 'Eway Bills Report', JobID: 483, reportNo: 12 }, //v2
    { name: 'Party Booking Report', JobID: 485, reportNo: 13 }, //v2
    { name: 'User Wise Collection Report', JobID: 62, reportNo: 14 }, //v1
    { name: 'Card and UPI Report', JobID: 602, reportNo: 40 },
    { name: 'Goods Balance Report', JobID: 190, reportNo: 15 }, //v1
    { name: 'Booking And Delivery Tracking', JobID: 193, reportNo: 16, encryptParams: true }, //v1
    { name: 'Cargo Unloading Report', JobID: 197, reportNo: 17 }, //v1
    { name: 'LR Cancel Penalty Report', JobID: 19, reportNo: 18 }, //v1
    { name: 'User With Transaction Right Report', JobID: 552, reportNo: 20 }, //v1
    { name: 'Party Business Report', JobID: 550, reportNo: 21 }, //v1
    { name: 'Failed Transactions Penalty Report', JobID: 551, reportNo: 22 }, //v1//551
    { name: 'Luggage Modification Report', JobID: 349, reportNo: 51 },
    { name: 'Branch Stock Report', JobID: 69, reportNo: 23 }, //v1//551
    { name: 'To Pay Destination Report', JobID: 195, reportNo: 24 }, //v1//551
    // { name: 'Receipt Register', JobID: 552, reportNo: 23 }, //v1//551
    { name: 'Franchise Outstanding', JobID: 558, reportNo: 25 }, //v1//551
    { name: 'Receipt Register', JobID: 552, reportNo: 26 }, //v1//551
    { name: 'Dispatch Register', JobID: 149, reportNo: 100 }, //v2
    { name: 'To-Pay Statement Report', JobID: 551, reportNo: 30 }, //v1//551
    { name: 'User Wise Collection with Expense', JobID: 566, reportNo: 31 }, //v1//551
    { name: 'Branch Balance Report', JobID: 569, reportNo: 32 }, //v1//551
    { name: 'Recharge History Report', JobID: 570, reportNo: 33 }, //v1//551
    { name: 'Vehicle Wise Voucher', JobID: 587, reportNo: 34 },
    { name: 'Monthly Target Report', JobID: 424, reportNo: 35 },
    { name: 'Short Receive Report', JobID: 267, reportNo: 36 },
    [STA_COMPANY_ID, DEMO_COMPANY].includes(intCompanyID) && { name: 'Commission Summary Report', JobID: 596, reportNo: 37 },
    [STA_COMPANY_ID, DEMO_COMPANY].includes(intCompanyID) && { name: 'Cartage Summary Report', JobID: 598, reportNo: 38 },
].filter(Boolean)

export const getAccountingReportList = (CurrencyID = 0, CompanyID = 1) => {
    const isRajeshTransport = CompanyID === RAJESH_TRANSPORT
    let arr =
        [
            { name: 'Branch Credit Limit Transaction', JobID: 217, reportNo: 3, reportType: 'accounting' },
            { name: 'Branch Credit Limit Summary', JobID: 216, reportNo: 4, reportType: 'accounting' },
            { name: 'Party Credit Limit Transaction', JobID: 262, reportNo: 8, reportType: 'accounting' },
            { name: 'Party Credit Limit Summary', JobID: 262, reportNo: 9, reportType: 'accounting' },
            { name: 'Credit Limit Usage Report', JobID: 253, reportNo: 5, reportType: 'accounting' },
            { name: 'GST Report', JobID: 321, reportNo: 2, reportType: 'accounting' },
            { name: 'GST ReportV1', JobID: 321, reportNo: 20, reportType: 'accounting' },
            { name: 'GST Return File', JobID: 514, reportNo: 1, reportType: 'accounting' },
            { name: 'Generate Hisab Report', JobID: 204, reportNo: 6, reportType: 'accounting' },
            { name: 'Franchisee Pending ToPay Report', JobID: 204, reportNo: 10, reportType: 'accounting' },
            { name: 'Franchisee Settlement Report', JobID: 204, reportNo: 11, reportType: 'accounting' },
            { name: 'Branch Wise & Dispatch Memo Collection', JobID: 568, reportNo: 13, reportType: 'accounting' },
            CurrencyID === 2 && { name: 'Mpesa Transaction Report', JobID: null, reportNo: 12, reportType: 'accounting' },
            CurrencyID === 2 && { name: 'Banking Report', JobID: null, reportNo: 21, reportType: 'acounting' },

            isRajeshTransport && { name: 'Branch Due Report', JobID: 579, reportNo: 14, reportType: 'accounting' },
            isRajeshTransport && { name: 'Branch Payable Report', JobID: 580, reportNo: 15, reportType: 'accounting' },
            isRajeshTransport && { name: 'Booking Summary Report', JobID: 581, reportNo: 16, reportType: 'accounting' },
            isRajeshTransport && { name: 'Profit & Loss Report', JobID: 582, reportNo: 17, reportType: 'accounting' },
            isRajeshTransport && { name: 'OGPL Report', JobID: 583, reportNo: 18, reportType: 'accounting' },
            isRajeshTransport && { name: 'OGCL Report', JobID: 584, reportNo: 19, reportType: 'accounting' },
            { name: 'Bus & Cargo Memo', JobID: 448, reportNo: 7, reportType: 'accounting' }
        ].filter(Boolean)
    return arr
}

export const generateURL = (report, loginData) => {
    const {
        intCompanyID, intUserID, intBranchID, strCompanyName,
        strUserName, strBranchName, intBranchCityID, strCityName,
        IsBranchAdmin, IsMTPLAdmin, IsAdmin, BusCrsCheckSum, DefaultCurrencyID,
        UseFormattedLRinReports, UseToPayAsCOD, AllowViewAllBranchReport,
        AllowViewAllBranchOfCityReport, AllowBranchInchargeRights,
        AllowExportExcel, AllowGroupofCompanies, token

    } = loginData


    const view = report.reportType === 'accounting' ? 'Acounting Reports' : 'Reports'
    const id = report.reportNo
    const params = new URLSearchParams({
        C: intCompanyID,
        U: intUserID,
        B: intBranchID,
        CT: intBranchCityID,
        CTN: strCityName,
        CN: strCompanyName,
        UN: strUserName,
        BN: strBranchName,
        IBA: IsBranchAdmin,
        IMPTLA: IsMTPLAdmin,
        IA: IsAdmin,
        CHK: BusCrsCheckSum,
        DC: DefaultCurrencyID,
        UFLR: UseFormattedLRinReports,
        TPAsCOD: UseToPayAsCOD,
        UseToPayAsCOD: UseToPayAsCOD,
        UseFormattedLRinReports: UseFormattedLRinReports,
        AllowViewAllBranchReport: AllowViewAllBranchReport,
        AllowViewAllBranchOfCityReport: AllowViewAllBranchOfCityReport,
        AllowBranchInchargeRights: AllowBranchInchargeRights,
        AllowExportExcel: AllowExportExcel,
        AllowGroupofCompanies: AllowGroupofCompanies,
    })

    if (report.encryptParams === false) {
        const plainParams = new URLSearchParams({
            view,
            id,
        })

        params.forEach((value, key) => {
            plainParams.set(key, value)
        })

        return `/?${plainParams.toString()}`
    }

    const encryptedReportParams = new URLSearchParams(params)
    if (token) {
        encryptedReportParams.set('token', token)
    }

    const encryptedParams = encrypt(encryptedReportParams.toString())
    const routeParams = new URLSearchParams({
        view,
        id,
        data: encryptedParams,
    })

    return `/?${routeParams.toString()}`
}
